import { ComponentChildren, h } from "preact";
import "./Badge.scss";

interface Props {
    children: ComponentChildren;
    className?: string;
}

export const Badge = ({ className, children }: Props) => <div className={`badge bf0 ${className ?? ""}`}>{children}</div>;
